/* Tha Layover — PDP sticky add-to-bag bar, mirrors the main product form */
(function () {
  'use strict';
  function init(bar) {
    if (bar.dataset.bound) return;
    var page = document.querySelector('tl-product-page');
    if (!page) return;
    var form = page.querySelector('form.tl-buy-form');
    var mainBtn = page.querySelector('[data-add-to-cart]');
    var mainSel = page.querySelector('[data-variant-select]');
    var groups = page.querySelector('.tl-option-groups');
    if (!form || !mainBtn || !mainSel) return;
    bar.dataset.bound = '1';

    var sel = bar.querySelector('[data-sticky-variant]');
    var btn = bar.querySelector('[data-sticky-add]');
    var txt = bar.querySelector('[data-sticky-text]');
    var price = bar.querySelector('[data-sticky-price]');
    var cmp = bar.querySelector('[data-sticky-compare]');
    var variants = [];
    try { variants = JSON.parse(page.querySelector('[data-variants]').textContent || '[]'); } catch (e) {}

    function sync() {
      if (sel && mainSel.value) sel.value = mainSel.value;
      btn.disabled = mainBtn.disabled;
      var label = page.querySelector('[data-add-text]');
      if (label) txt.textContent = label.textContent;
      var p = page.querySelector('[data-product-price]');
      if (p) price.innerHTML = p.innerHTML;
      var c = page.querySelector('[data-compare-price]');
      if (c) { cmp.innerHTML = c.innerHTML; cmp.hidden = c.hidden; }
    }
    page.addEventListener('change', function () { setTimeout(sync, 0); });

    if (sel) sel.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === sel.value; });
      if (!v) return;
      if (groups && !groups.hidden) {
        groups.querySelectorAll('[data-option-index]').forEach(function (f, i) {
          var r = Array.prototype.find.call(f.querySelectorAll('input'), function (inp) { return inp.value === v.options[i]; });
          if (r) r.checked = true;
        });
        groups.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        mainSel.value = sel.value;
        mainSel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    btn.addEventListener('click', function () {
      if (mainBtn.disabled || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      form.requestSubmit(mainBtn);
      setTimeout(function () { btn.classList.remove('is-loading'); }, 1100);
    });

    var past = false, footerIn = false;
    function show() {
      var on = past && !footerIn;
      bar.classList.toggle('is-visible', on);
      bar.toggleAttribute('inert', !on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('tl-sticky-buy-on', on);
    }
    new IntersectionObserver(function (e) {
      past = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; show();
    }).observe(mainBtn);
    var end = document.querySelector('.tl-newsletter, .tl-footer');
    if (end) new IntersectionObserver(function (e) { footerIn = e[0].isIntersecting; show(); }).observe(end);
    sync();
  }
  document.querySelectorAll('[data-sticky-buy]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-sticky-buy]').forEach(init); });
})();
